import * as React from 'react';

import { getRangeValue } from '../../../../../JsonQuery';
import { FromMKAD } from '../../../components/advancedFilters/FromMKAD';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const FromMKADContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const fromMKAD = getRangeValue('from_mcad_km')(jsonQuery);

  const handleFromMKADMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setFromMKADMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleFromMKADMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setFromMKADMax', arguments: [lte] });
    },
    [onChange],
  );

  return (
    <FromMKAD
      distance={fromMKAD}
      onFromMKADMinChange={handleFromMKADMinChange}
      onFromMKADMaxChange={handleFromMKADMaxChange}
    />
  );
};
